import { Component, Input, OnInit } from '@angular/core';

import { MailAttachmentType } from './mail-attachment-type';

@Component({
  selector: 'mail-attachment',
  templateUrl: './history-mail-attachment.component.html',
  styleUrls: ['./history-mail-attachment.component.scss'],
})
export class HistoryMailAttachmentComponent implements OnInit {
  @Input() public attachmentFile: string;
  @Input() public attachmentSource: string;
  extensionAndSize: string;
  fileName: string;

  ngOnInit() {
    this.fileName = this.attachmentFile.split('.')[0];
    this.extensionAndSize = this.attachmentFile.split('.')[1];
  }

  getClassName() {
    const className = MailAttachmentType[this.extensionAndSize.split('-')[0].trim().toUpperCase()];

    return className ? className : 'cng-ico_attach';
  }
}
